import { defineComponent as _defineComponent } from 'vue'
import { ref, ComponentPublicInstance } from "vue";
import { UserMaster } from "@/models/user-master/UserMasterResponse";
import UserMasterSearch from "@/components/master/user/UserMasterSearch.vue";
import UserMasterTable from "@/components/master/user/UserMasterTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMaster',
  setup(__props) {

const items = ref<UserMaster[]>([]);

const search = ref<ComponentPublicInstance<typeof UserMasterSearch>>();

const onSearch = (val: UserMaster[]) => {
  items.value = val;
};
const onSubmit = () => {
  search.value?.onSearch();
};

return { __sfc: true,items, search, onSearch, onSubmit, UserMasterSearch, UserMasterTable }
}

})